import React from 'react';
import { string, oneOfType, arrayOf, node, bool } from 'prop-types';

import Button from 'components/buttons/Button';

const SecondaryButton = ({
  as,
  children,
  disabled,
  href,
  margin,
  rel,
  size,
  target,
  width,
}) => (
  <Button
    as={as}
    bg={waffles => waffles.theme.colors.secondary}
    disabled={disabled}
    hoverBg={waffles => waffles.theme.colors.secondaryLight}
    href={href}
    margin={margin}
    rel={rel}
    size={size}
    target={target}
    textColor={waffles => waffles.theme.colors.greyDark}
    width={width}
  >
    {children}
  </Button>
);

SecondaryButton.defaultProps = {
  as: null,
  disabled: null,
  href: null,
  margin: null,
  rel: null,
  size: null,
  target: null,
  width: null,
};

SecondaryButton.propTypes = {
  as: string,
  children: oneOfType([arrayOf(node), node]).isRequired,
  disabled: bool,
  href: string,
  margin: string,
  rel: string,
  size: string,
  target: string,
  width: string,
};

export default SecondaryButton;
